import { render, staticRenderFns } from "./MainLearningContentTable.vue?vue&type=template&id=4ad82334&"
import script from "./MainLearningContentTable.vue?vue&type=script&lang=js&"
export * from "./MainLearningContentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports